<template>
  <div id="app">
  <router-view />
  </div>
</template>

<script>
import axios from 'axios'
import { Notification } from 'element-ui'

export default {
  name: 'App',
  components:{
  },
  data() {
    return {
      currentVersion: null, // 当前版本号
      versionCheckTimer: null, // 版本检测定时器
      checkInterval: 5 * 60 * 1000, // 检测间隔：5分钟
      isFirstCheck: true, // 是否首次检测
      currentNotification: null // 当前显示的更新通知实例
    }
  },
  mounted(){
    this.initVersionCheck()
  },
  beforeDestroy() {
    if (this.versionCheckTimer) {
      clearInterval(this.versionCheckTimer)
    }
    // 清理当前显示的通知
    if (this.currentNotification) {
      this.currentNotification.close()
      this.currentNotification = null
    }
  },
  methods: {
    // 初始化版本检测
    initVersionCheck() {
      this.getCurrentVersion()
      this.versionCheckTimer = setInterval(() => {
        this.checkForUpdates()
      }, this.checkInterval)
    },
    
    // 获取当前版本
    async getCurrentVersion() {
      try {
        const response = await axios.get('/version.json?t=' + Date.now(), {
          timeout: 10000,
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          }
        })
        
        if (response.data && response.data.version) {
          this.currentVersion = response.data.version
          // console.log('当前版本:', this.currentVersion)
        }
      } catch (error) {
        console.warn('获取版本信息失败:', error)
      }
    },
    
    // 检查版本更新

    async checkForUpdates() {
      try {
        const response = await axios.get('/version.json?t=' + Date.now(), {
          timeout: 10000,
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          }
        })
        
        if (response.data && response.data.version) {
          const latestVersion = response.data.version
          
          if (this.currentVersion && latestVersion !== this.currentVersion && !this.isFirstCheck) {
            this.handleVersionUpdate()
          }
          
          this.currentVersion = latestVersion
          this.isFirstCheck = false
        }
      } catch (error) {
        console.warn('检查版本更新失败:', error)
      }
    },
    
    /**
     * 处理版本更新
     */
    handleVersionUpdate() {
      const currentRoute = this.$route.name
      
      // 判断是否为大屏页面（MonitorDashboard 和 ShowOn2K）
      const isLargeScreenPage = currentRoute === 'MonitorDashboard' || 
                               currentRoute === '2kWithId' || 
                               currentRoute === '2kENWithId' ||
                               this.$route.path.includes('/2k/') ||
                               this.$route.path.includes('/2kmobile/') ||
                               this.$route.path.includes('/2k-en/') ||
                               this.$route.path.includes('/2kmobile-en/')
      
      if (isLargeScreenPage) {
        // 大屏页面：立即强制刷新
        this.forceReload()
      } else {
        // 其他页面：提示用户刷新
        this.showUpdateNotification()
      }
    },
    
    /**
     * 显示更新通知
     */
    showUpdateNotification() {
      // 如果已有更新通知，先关闭它
      if (this.currentNotification) {
        this.currentNotification.close()
        this.currentNotification = null
      }
      
      // 显示新的更新通知
      this.currentNotification = Notification({
        title: '系统更新提醒',
        message: '检测到系统新版本，点击立即刷新页面',
        type: 'info',
        duration: 0, // 不自动关闭
        position: 'top-right',
        showClose: true,
        customClass: 'version-update-notification',
        onClick: () => {
          // 点击通知强制刷新页面
          this.forceReload()
        },
        onClose: () => {
          // 通知关闭时清空引用
          this.currentNotification = null
        }
      })
    },
    
    /**
     * 强制刷新页面（相当于Ctrl+F5）
     */
    forceReload() {
      const timestamp = Date.now()
      const currentUrl = window.location.href
      const separator = currentUrl.includes('?') ? '&' : '?'
      window.location.href = `${currentUrl}${separator}_t=${timestamp}`
    }
  }
}
</script>

<style>
html,body,#app{
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
